import { ReactNode } from 'react';
import { useSelector } from 'react-redux-latest';
import { Navigate, useLocation } from 'react-router-dom';
import { LocalStorageKeys } from '../config';
import { authStates } from '../redux/authStates';
import { RootState } from '../redux/store/configureStore';
import { paths } from '../routes/paths';
import { Loader } from '../views/auth/containers';

const EnsureAuthenticated = ({ children }: { children?: ReactNode }) => {
    const location = useLocation();
    const auth = useSelector((state: RootState) => state.user);
    const preventRedirectToLogin = useSelector((state: RootState) => state.user.preventRedirectToLogin);
    const isNotHomeOrCampaigns = location.pathname !== paths.HOME && location.pathname !== paths.PROSPECT_COLLECTIONS;
    const redirectToURL = localStorage.getItem(LocalStorageKeys.REDIRECT_TO_URL);
    if (preventRedirectToLogin) {
        return <Loader />;
    }

    if (auth.currentState === authStates.CHOOSE_ORGANIZATION && isNotHomeOrCampaigns) {
        return <>{children}</>;
    }

    if (auth.currentState === authStates.FULLY_CONFIGURED && redirectToURL) {
        return <Navigate to={redirectToURL} />;
    }

    if (auth.currentState === authStates.UNKNOWN) {
        return <Loader />;
    }

    return (
        <>
            {auth.currentState === authStates.FULLY_CONFIGURED ? (
                <>{children}</>
            ) : auth.currentState === authStates.NOT_CONFIGURED ? (
                <Navigate to={paths.CONFIGURE_PROFILE} />
            ) : (
                <Navigate to={paths.LOGIN} />
            )}
        </>
    );
};

export default EnsureAuthenticated;
